export default __webpack_public_path__ + "static/media/tailwindcss.fd75e841.svg";